<button
  type="button"
  pButton
  icon="fa fa-fw fa-caret-down"
  iconPos="right"
  class="p-button-text"
  [label]="label | translate"
  (click)="batchActions.toggle($event)"
  [disabled]="disabled"
></button>
<p-tieredMenu #batchActions [model]="model" [popup]="true" appendTo="body"></p-tieredMenu>
